import React from 'react';

interface TableSkeletonProps {
  rows?: number;
  columns?: number;
}

export const TableSkeleton = ({ rows = 10, columns = 5 }: TableSkeletonProps) => {
  return (
    <div className="w-full animate-pulse">
      {/* Header Skeleton */}
     

      {/* Table Skeleton */}
      <div className="min-w-full divide-y divide-gray-200">
        {/* Table Header */}
        <div className="bg-gray-50">
          <div className="grid grid-cols-5 gap-4 px-4 py-3">
            {Array(columns)
              .fill(0)
              .map((_, index) => (
                <div key={`header-${index}`} className="h-4 bg-gray-200 rounded w-full"></div>
              ))}
          </div>
        </div>

        {/* Table Body */}
        <div className="bg-white divide-y divide-gray-200">
          {Array(rows)
            .fill(0)
            .map((_, rowIndex) => (
              <div
                key={`row-${rowIndex}`}
                className="grid grid-cols-5 gap-4 px-4 py-8 hover:bg-gray-50"
              >
                {Array(columns)
                  .fill(0)
                  .map((_, colIndex) => (
                    <div
                      key={`cell-${rowIndex}-${colIndex}`}
                      className={`h-4 bg-gray-200 rounded-md ${
                        colIndex === 0 ? 'w-3/4' : colIndex === columns - 1 ? 'w-1/2' : 'w-full'
                      }`}
                    ></div>
                  ))}
              </div>
            ))}
        </div>
      </div>

      {/* Pagination Skeleton */}
      <div className="flex items-center justify-between mt-4 px-4">
        <div className="h-4 w-48 bg-gray-200 rounded"></div>
        <div className="flex gap-2">
          {Array(3)
            .fill(0)
            .map((_, index) => (
              <div key={`page-${index}`} className="h-8 w-8 bg-gray-200 rounded"></div>
            ))}
        </div>
        <div className="h-8 w-32 bg-gray-200 rounded"></div>
      </div>
    </div>
  );
};
